import { useAccount } from '../../../../common/useAccount'
import { MeetingPrepEmailNotifications } from './MeetingPrepEmailNotifications'
import { MeetingProcessedDoneNotification } from './MeetingProcessedDoneNotification'
import { Col, Row } from 'react-bootstrap'

export const EmailNotificationSettings = () => {
  const { account } = useAccount({ refetchOnMountOrArgChange: true })

  if (!account) {
    return null
  }

  return (
    <div className='d-flex flex-column gap-4'>
      <h4>Email Notifications</h4>
      <Row className='p-3 zocks-bg-color-primary-light gap-3 justify-content-center rounded mx-0 my-2'>
        <Col className='d-flex align-items-center zocks-gap-2.5 align-self-center'>
          <div className='d-flex align-self-center gap-3 align-items-center'>
            <i className='bi bi-info-square zocks-text-primary consent-settings-info-square' />
            <div className='d-flex flex-column'>
              <span>Enable the notifications your team needs. Customize email content and recipients.</span>
            </div>
          </div>
        </Col>
      </Row>
      <MeetingPrepEmailNotifications account={account} />
      <MeetingProcessedDoneNotification account={account} />
    </div>
  )
}
